export const disciplineStyles = {
    option: (provided, state) => {
        const label = state.data.label || "";
        const suffix = label.split("-")[1]?.trim();  // SF / AIDED

        let color = "black";
        if (suffix === "SF") color = "#252393";
        if (suffix === "AIDED") color = "green";

        return {
            ...provided,
            backgroundColor: state.isSelected ? "#ebebeb" : "white",
            color: color,
            fontWeight: state.isSelected ? "600" : "normal",
        };
    },

    singleValue: (provided, state) => {
        const label = state.data.label || "";
        const suffix = label.split("-")[1]?.trim();

        let color = "black";
        if (suffix === "SF") color = "#252393";
        if (suffix === "AIDED") color = "green";

        return {
            ...provided,
            color: color,
            fontWeight: "600",
        };
    },

    menu: (provided) => ({
        ...provided,
        maxHeight: "200px",
        overflowY: "auto",
    }),

    menuList: (provided) => ({
        ...provided,
        maxHeight: "200px",
        overflowY: "auto",
        scrollbarWidth: "thin",
        scrollbarColor: "#888 #f1f1f1",
    }),

    multiValue: (provided) => ({
        ...provided,
        "&::-webkit-scrollbar": { width: "8px" },
        "&::-webkit-scrollbar-track": { background: "#f1f1f1" },
        "&::-webkit-scrollbar-thumb": { background: "#888", borderRadius: "4px" },
        "&::-webkit-scrollbar-thumb:hover": { background: "#555" },
    }),
};
